import React from 'react';
import { motion } from 'framer-motion';
import { createMonzoLink } from '../utils/paymentLinks';

const Gifts: React.FC = () => {
  const honeymoonActivities = [
    {
      title: 'Romantic Dinner for Two',
      description: "Omakase at Jiro Ono's famous sushi restaurant",
      price: '£100',
      location: 'Tokyo'
    },
    {
      title: 'Tickets to Tokyo DisneySea',
      description: 'What could be more Japanese then a trip to meet Mickey Mouse?',
      price: '£50',
      location: 'Maihama'
    },
    {
      title: 'Wagyu Beef Tasting Experience',
      description: 'Our first time trying Japanese Wagyu A5',
      price: '£65',
      location: 'Osaka'
    },
    {
      title: 'Ski Lesson',
      description: "A day on the slopes of Japan's premier ski resort, with a(nother) ski instructor",
      price: '£120',
      location: 'Niseko'
    },
  ];

  return (
    <div className="bg-gradient-to-br from-cream via-white to-blush py-12 px-4" style={{ minHeight: '100vh', paddingBottom: '20vh' }}>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h1 className="page-header text-charcoal mb-4">
            Gifts
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="bg-white/80 backdrop-blur-sm rounded-lg p-8 shadow-lg text-center mb-12"
        >
          <p className="body-text text-gray-700 mb-6">
            We truly don't need any gifts - your love, laughter, and memories are more than enough.
          </p>
          <p className="body-text text-gray-light">
            However, if you would like to contribute something, our honeymoon will be in Japan, 
            and we've put together some experiences we're hoping to enjoy together...
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mb-8"
        >
          <h2 className="section-header text-charcoal text-center mb-8">
            Honeymoon Experiences
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {honeymoonActivities.map((activity, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 + index * 0.1 }}
                className="bg-white/70 backdrop-blur-sm rounded-lg p-6 shadow-lg text-center"
              >
                <div className="mb-3">
                  <h3 className="subheading text-charcoal mb-1">
                    {activity.title}
                  </h3>
                  <span className="small-text text-gray-light">{activity.location}</span>
                </div>
                <p className="body-text text-gray-light mb-4">
                  {activity.description}
                </p>
                <div className="mb-4">
                  <span className="section-header font-medium text-gold">
                    {activity.price}
                  </span>
                </div>
                <a
                  href={createMonzoLink(activity.price, `Wedding Gift - ${activity.title}`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-6 py-2 text-charcoal hover-text-gold transition-colors duration-300 button-text tracking-wider bg-transparent hover-bg-white-50 rounded"
                  style={{ fontSize: '0.8rem' }}
                >
                  Contribute to this gift
                </a>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="text-center p-6 bg-white/60 rounded-lg"
        >
          <p className="body-text text-gray-light">
            Each contribution, no matter the size, helps us create magical memories together. 
            Thank you for being part of our adventures!
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Gifts;